module.exports = __webpack_public_path__ + "assets/noEdit.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/noEdit.svg
// module id = 356
// module chunks = 0